<template>
  <div class="wrap">
    <component :is="currentView" :ref="currentView" :defaultQuery="defaultQuery" :permission="permission"></component>
    <!-- <keep-alive :exclude="excludedComponents">
    </keep-alive> -->
  </div>
</template>

<script>
/* global Vue:true */
const importRegular = file => require('@/layout/regularPage/' + file + '.vue').default
const importCustom = file => require('@/layout/customPage/' + file + '.vue').default

export default {
  props: {
    level1: '',
    level2: ''
  },
  data () {
    return {
      currentView: '',
      defaultQuery: {}, // 页面配置参数
      permission: {
        flag: false, // 页面按钮是否做权限控制
        buttons: [] // 页面资源权限列表
      } // 页面资源权限
    }
  },
  mounted () {
    const _self = this;
    _self.initContent()
  },
  watch: {
    '$route' (to, from) {
      this.initContent()
    }
  },
  computed: {
    excludedComponents () {
      return this.$store.state.excludedComponents
    }
  },
  methods: {
    initContent () {
      const _self = this
      let path = _self.$route.path;
      let mapPermission = _self.$store.state.mapPermission;
      let level1, level2;

      if (path.startsWith('/shell/regular/')) {
        let menu = path.split('/shell/regular/')[1];
        if (_self.level1) {
          level1 = _self.level1;
          level2 = _self.level2;
        } else {
          [level1, level2] = menu.split('/');
        }
        if (mapPermission[level1] && mapPermission[level1].show && (!level2 || (mapPermission[level1].pageMap && mapPermission[level1].pageMap[level2]))) {
          // 判断当前模块是否授权 && 当前页面是否授权
          // 模板定制
          let regularComponent = (menu || '').replace(/\//g, '_')
          let _component = 'regular' + '_' + regularComponent
          _self.defaultQuery = mapPermission[level1].pageMap[level2].query;
          // todo 根据提供的清单来判断是否做资源控制
          _self.permission.buttons = [];
          let buttons = mapPermission[level1].pageMap[level2].children || [];
          for (let button of buttons) {
            _self.permission.buttons.push(button.url);
          }
          Vue.component(_component, Vue.extend(importRegular('index')))
          _self.currentView = _component
        } else {
          _self.$router.push({path: '/shell/noPermission'})
        }
      } else if (path.startsWith('/shell/custom/')) {
        // 直接读取页面
        let customPath = path.split('/shell/custom/')[1];
        if (_self.level1) {
          level1 = _self.level1;
          level2 = _self.level2;
        } else {
          [level1, level2] = customPath.split('/');
        }
        if (mapPermission[level1] && mapPermission[level1].show && (!level2 || (mapPermission[level1].pageMap && mapPermission[level1].pageMap[level2]))) {
          let regularComponent = (customPath || '').replace(/\//g, '_')
          let _component = 'custom' + '_' + regularComponent
          _self.defaultQuery = mapPermission[level1].pageMap[level2].query;
          // todo 根据提供的清单来判断是否做资源控制
          _self.permission.buttons = [];
          let buttons = mapPermission[level1].pageMap[level2].children || [];
          for (let button of buttons) {
            _self.permission.buttons.push(button.url);
          }
          try {
            Vue.component(_component, Vue.extend(importCustom(customPath)))
            _self.currentView = _component
          } catch (e) {
            _self.$router.push({path: '/shell/404'})
          }
        } else {
          _self.$router.push({path: '/shell/noPermission'})
        }
      } else if (/\/shell\/.*\/custom\//.test(path)) {
        let customMenu = path.split('/custom/')[0].split('/shell/')[1];
        let customPath = path.split('/custom/')[1];
        if (_self.level1) {
          level1 = _self.level1;
          level2 = _self.level2;
        } else {
          level1 = customMenu;
          level2 = customPath.split('/')[customPath.split('/').length - 1];
        }
        if (mapPermission[level1] && mapPermission[level1].show && (!level2 || (mapPermission[level1].pageMap && mapPermission[level1].pageMap[level2]))) {
          let regularComponent = (customPath || '').replace(/\//g, '_')
          let _component = 'custom' + '_' + regularComponent
          _self.defaultQuery = mapPermission[level1].pageMap[level2].query;
          // todo 根据提供的清单来判断是否做资源控制
          _self.permission.buttons = [];
          let buttons = mapPermission[level1].pageMap[level2].children || [];
          for (let button of buttons) {
            _self.permission.buttons.push(button.url);
          }
          try {
            Vue.component(_component, Vue.extend(importCustom(customPath)))
            _self.currentView = _component
          } catch (e) {
            _self.$router.push({path: '/shell/404'})
          }
        } else {
          _self.$router.push({path: '/shell/noPermission'})
        }
      } else if (!path.includes('/dashboard') && !path.includes('/noPermission')) {
        _self.$router.push({path: '/shell/404'})
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/home/mainContent.vue